import { useAuth0 } from '@auth0/auth0-react';
import { ErrorableLoader } from '@bordrio/ui-components';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import UserRegisterModal from '../UserRegisterModal';

interface Props {
  children: JSX.Element;
}

const ROLES_CLAIM = 'https://app.com/roles';

function UserRegisterGate({ children }: Props): JSX.Element {
  const { user: auth0User } = useAuth0();
  const { user, error } = useCurrentUser();

  const rolesClaim = auth0User && (auth0User[ROLES_CLAIM] as string[]);
  const hasCustomerRole =
    Array.isArray(rolesClaim) && rolesClaim.includes('customer');

  if (!hasCustomerRole) {
    if (!user) {
      return <ErrorableLoader error={error} />;
    }

    if (!user.isRegistered) {
      return <UserRegisterModal user={user} />;
    }
  }

  if (user && !user.isRegistered) {
    return <UserRegisterModal user={user} />;
  }

  return children;
}

export default UserRegisterGate;
